import React, { Component } from 'react';
import Radium from 'radium';
import Waves from 'node-waves'
import $ from 'jquery'
import { greyScaleColors, semanticColors } from '../../Globals/styles'

class StickyNoteDropModal extends Component {
  constructor(props) {
    super(props);
    if ('id' in props.droppedStickynote)
    {
      this.state = {
        id: props.droppedStickynote.id,
        color: props.droppedStickynote.color,
        text: props.droppedStickynote.text,
        isEdit: true,
        isDelete: false
      }
    } else {
      this.state = {
        id: 'dummyId',
        color: semanticColors.warningLight,
        text: '',
        isEdit: false
      } 
    }
  }
  componentDidMount = () => {
    this.forceFocusTextArea();
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  componentDidUpdate = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  changeNoteColor = (color) =>{
    this.setState({
      color: color
    });
  };
  handleOnChange = (evt) =>{
    let text = evt.target.value;
    this.setState({
      text: text
    });
  };
  onSave = () => {
    const { droppedStickynote, addStickyNoteToWeekday } = this.props;
      addStickyNoteToWeekday(droppedStickynote.weekdayIndex, droppedStickynote.employeeIndex,{id: this.state.id ,color : this.state.color, text: this.state.text})
  };
  onDelete = () => {
    const { attemptDeleteStickyNote ,droppedStickynote} = this.props;
      attemptDeleteStickyNote(droppedStickynote.weekdayIndex, droppedStickynote.employeeIndex, droppedStickynote.stickyNoteIndex, this.state.id)
  };

  onUpdate = () => {
    const {droppedStickynote, attemptEditStickyNote} = this.props;
    attemptEditStickyNote(droppedStickynote.weekdayIndex, droppedStickynote.employeeIndex,{id: this.state.id, color : this.state.color, text: this.state.text}, droppedStickynote.stickyNoteIndex)
  };

  forceFocusTextArea = () =>{
    if(this.state.text === '')
    $(this.refs.textarea).focus().val();
  };

  render () {
    const { cancelStickynoteDrop } = this.props;
    const { isEdit, isDelete } = this.state;
    return (
      <div>
        <div style={styles.overlay}></div>
        <div style={styles.modal}>
          {isDelete ? 
          <div style={styles.isDelete}>
                <i
                  className="fa fa-times"
                  aria-hidden="true"
                  style={styles.closeIcon}
                  onClick={cancelStickynoteDrop}></i>
                <div>
                  <h3>Er du sikker på du vil slette?</h3>
                </div>
                <button style={[styles.button, styles.deleteBtn]} onClick={this.onDelete} className="btn btn-danger waves-btn"> Ja! </button>
          </div>
          :
          <div>
            <i
              className="fa fa-times waves-icon"
              aria-hidden="true"
              style={styles.closeIcon}
              onClick={cancelStickynoteDrop}
            ></i>
            <div style={styles.content}>
              <textarea ref="textarea" style={[styles.textarea, {backgroundColor: this.state.color}]}
                onChange={this.handleOnChange}
                defaultValue={this.state.text}
              ></textarea>
              <div style={styles.colorsContainer}>
                <div style={styles.farve}>farve:</div>
                <button className="waves-btn" style={[styles.colorButtons,styles.infoLight]}
                        onClick={()=>this.changeNoteColor(semanticColors.infoLight)}></button>
                <button className="waves-btn" style={[styles.colorButtons,styles.dangerLight]}
                        onClick={()=>this.changeNoteColor(semanticColors.dangerLight)}></button>
                <button className="waves-btn" style={[styles.colorButtons,styles.primaryLight]}
                          onClick={()=>this.changeNoteColor(semanticColors.primaryLight)}></button>
                <button className="waves-btn" style={[styles.colorButtons,styles.warningLight]}
                        onClick={()=>this.changeNoteColor(semanticColors.warningLight)}></button>
              </div>
              <div style={styles.bottomContainer}>
              {isEdit ?
                <div>
                  <button style={styles.button} className="btn btn-danger waves-btn pull-left" 
                    onClick={()=>{this.setState({isDelete: true})}}> Slet </button>
                  <button style={styles.button} className="btn btn-success waves-btn pull-right" onClick={this.onUpdate}>Gem</button>
                </div>
                :
                <button style={styles.button} className="btn btn-success waves-btn pull-right" onClick={this.onSave}>Gem</button>}
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    );
  }
}

var styles = {
  overlay: {
    width:'100%',
    height: '100%',
    position: 'fixed',
    top: '0',
    left: '0',
    backgroundColor: greyScaleColors.grey,
    opacity: '0.6',
    zIndex: '10'
  },
  modal:{
    position: 'fixed',
    top: '50%',
    left: '50%',
    zIndex: '11',
    backgroundColor: semanticColors.default,
    width: '280px',
    height: '260px',
    marginTop: '-130px',
    marginLeft: '-140px',
    textAlign: 'center',
    borderRadius: '2px',
    lineHeight: '40px',
    padding: '20px'
  },
  startTimeInput: {
    display: 'inline-block',
    height: '40px',
    width: '240px'
  },
  button:{
    borderRadius: '2px',
    minWidth: '70px'
  },
  closeIcon: {
    position: 'absolute',
    top: '0px',
    right: '0px',
    fontSize: '20px',
    height: '30px',
    lineHeight: '30px',
    width: '30px',
    zIndex: '10'
  },
  isDelete: {
    paddingTop: '70px'
  },
  content:{
    position: 'relative',
    paddingTop: '5px',
    height: '100%',
    width: '100%',
    textAlign: 'center'
  },
  textarea:{
    width: '100%',
    fontSize: '14px',
    lineHeight: '20px',
    backgroundColor: semanticColors.warningLight,
    height: '125px',
    border: '0px',
    borderRadius: '2px',
    resize: 'none'
  },
  colorsContainer:{
    float: 'left',
    height: '40px',
    lineHeight: '40px',
    width: '100%',
    marginBottom: '10px'
  },
  colorButtons:{
    width: '20px',
    height: '20px',
    margin: '10px 0px 0px 10px',
    borderRadius: '2px',
    border: '0px',
    cursor: 'pointer',
    padding: '0px',
    float: 'right'
  },
  farve:{
    float: 'left'
  },
  bottomContainer:{
    width: '100%'
  },
  warningLight:{
    backgroundColor: semanticColors.warningLight
  },
  successLight: {
    backgroundColor: semanticColors.successLight
  },
  primaryLight: {
    backgroundColor: semanticColors.primaryLight
  },
  infoLight: {
    backgroundColor: semanticColors.infoLight
  },
  dangerLight: {
    backgroundColor: semanticColors.dangerLight
  },
  deleteBtn:{
    marginTop: '20px'
  }
}


export default Radium(StickyNoteDropModal)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/EmployeeWeekOverview/stickyNoteDropModal.jsx